import utils from '@/mixins/utils.js'

export const dataFieldsDias = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      return item.dt_nascimento != null
        ? utils.methods.formatDate(item.dt_nascimento)
        : ''
    },
  },
  Mãe: 'no_mae',
  Atendimento: {
    callback: (item) => {
      return item.dt_ult_atendimento != null
        ? utils.methods.formatDate(item.dt_ult_atendimento)
        : ''
    },
  },
  Outros: 'qtd_atends_us_outras',
  CPF: {
    field: 'nu_cpf',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  CNS: {
    field: 'nu_cns',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  Equipe: {
    field: 'ine_fci',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  Microárea: {
    field: 'micro_area',
    callback: (value) => {
      return value !== '' && value != null ? `​  ​​${value.toString()}` : ''
    },
  },
  'Cadastrado por': 'no_profissional',
}

export const dataFieldsMes = {}

export const dataFieldsEspera = {}

export const dataFieldsClassificacao = {}

export const infoHtml = ``
